/// <reference path="../../typings/browser.d.ts" />

namespace Application.Common {
   'use strict';
   
    /**
     * AltairUtils class, set of utility functions
     */
    export class AltairUtils {
        public static easingSwiftOut: number[] = [0.4, 0, 1, 1];
        
        public static hideSidebar($rootScope: IFlexRootScope): void {
            $rootScope.primarySidebarActive = false;
            $rootScope.primarySidebarOpen = false;
            // $("body").removeClass("sidebar_main_open sidebar_main_active");
        }

        public static showSidebar($rootScope: IFlexRootScope): void {
            $rootScope.primarySidebarActive = true;
            $rootScope.primarySidebarOpen = true;
            // $("body").attr('class', "sidebar_main_open" + ' ' + $('body').attr('class')); 
        }
    }
}